import axios from '../plugins/axios'

const getProcess = id => axios.get(`/process/${id}`)
const getProcesses = (companyId, status, documentId, fullName, skip, take) =>
  axios.get('/processes', {
    params: { companyId, status, documentId, fullName, skip, take }
  })
const getProcessCountsByStatus = (companyId, documentId, fullName) =>
  axios.get('/processes/count/status', {
    params: { companyId, documentId, fullName }
  })
const createProcess = process => axios.post('/process', process)
const createProcessesBulk = payload => axios.post('/process/bulk', payload)
const updateProcess = (processId, process) => axios.put(`/process/${processId}`, process)
const assignServiceByProcess = (serviceByProcessId, userAssigned, processId) => axios.put('/process/assign/service', { serviceByProcessId, userAssigned, processId })
const qualifyServiceByProcess = (serviceByProcessId, status, processId) => axios.put('/process/qualify/service/' + processId, { serviceByProcessId, status })

export { getProcess, getProcesses, getProcessCountsByStatus, createProcess, createProcessesBulk, updateProcess, assignServiceByProcess, qualifyServiceByProcess }
